/** @jsx jsx */
import { jsx } from '@emotion/react';

import gql from 'graphql-tag';
import { compact } from 'lodash';

import { Link } from '@coursera/cds-core';

import { prependUrlProtocolIfNone } from 'bundles/common/utils/urlUtils';
import withFragments from 'bundles/graphql/components/withFragments';
import type { Partners } from 'bundles/partners-graphql/types/Instructor';

type Props = {
  partners?: Partners | null;
};

export const PartnerLinksV2 = ({ partners }: Props) => {
  if (!partners || !partners.elements || !partners.elements.length) {
    return null;
  }

  return (
    <ul className="rc-PartnerLinksV2 list-style-none p-a-0">
      {compact(partners.elements).map((partner) => {
        if (!partner?.links?.website) {
          return null;
        }

        return (
          <li key={partner.id}>
            <Link
              variant="quiet"
              typographyVariant="bodySecondary"
              href={prependUrlProtocolIfNone(partner.links.website) || undefined}
            >
              {partner.name}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export const partnersFragment = gql`
  fragment PartnersFragment on PartnersV1Connection {
    elements {
      id
      shortName
      name
      links {
        website
      }
    }
  }
`;

export default withFragments({
  partners: partnersFragment,
})(PartnerLinksV2);
